<template>
  <div
    class="select-button"
    @click="action"
  >
    {{ buttonName }}
  </div>
</template>

<script>
export default {
  name: 'select-button-mobile',
  props: ['buttonName', 'action'],
  components: {
  },
  data() {
    return {
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
  .select-button {
    background-color: #af2f82;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    color: #fafafa;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60%;
    height: 3.3125rem;
    font-family: 'Poppins', sans-serif;
    text-transform: uppercase;
    margin: 1rem auto;
    cursor: pointer;
        font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: 0.15rem;
    padding: 0 2rem;
    white-space: nowrap;
  }
</style>
